import React from 'react';
import './SupportPages.css';

const About: React.FC = () => {
  return (
    <div className="support-page">
      <div className="container-narrow">
        <div className="support-header">
          <h1 className="section-title">회사 소개</h1>
          <p className="section-subtitle">
            기술로 비즈니스 커뮤니케이션을 혁신합니다
          </p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>주식회사 서울소프트</h2>
            <p className="lead-text">
              서울소프트는 2010년 설립 이래 기업 커뮤니케이션 솔루션 분야에서
              혁신적인 기술과 서비스를 제공해온 IT 전문 기업입니다.
            </p>
            <p>
              우리는 AI 음성합성 기술과 통신 인프라를 결합하여 기업의 업무 효율을
              극대화하는 EasyAutoCall 서비스를 개발했습니다. 배차 알림, 고객 안내,
              설문조사 등 다양한 비즈니스 시나리오에서 자동화된 전화 발신 솔루션을
              제공하여 고객사의 시간과 비용을 절감하고 있습니다.
            </p>
          </section>

          <section className="about-section">
            <h2>우리의 비전</h2>
            <div className="vision-grid">
              <div className="vision-item">
                <div className="vision-icon">🎯</div>
                <h3>혁신</h3>
                <p>최신 AI 기술을 활용한 스마트한 커뮤니케이션 솔루션 제공</p>
              </div>
              <div className="vision-item">
                <div className="vision-icon">💡</div>
                <h3>효율성</h3>
                <p>업무 프로세스 자동화를 통한 생산성 향상</p>
              </div>
              <div className="vision-item">
                <div className="vision-icon">🤝</div>
                <h3>신뢰</h3>
                <p>안정적인 서비스와 철저한 보안으로 고객 신뢰 구축</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>주요 연혁</h2>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-year">2024</div>
                <div className="timeline-content">
                  <h4>EasyAutoCall 서비스 정식 출시</h4>
                  <p>TTS 자동 전화 및 설문조사 플랫폼 런칭</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">2020</div>
                <div className="timeline-content">
                  <h4>AI 음성합성 기술 연구개발 착수</h4>
                  <p>차세대 TTS 엔진 개발 프로젝트 시작</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">2015</div>
                <div className="timeline-content">
                  <h4>기업용 통신 솔루션 사업 확장</h4>
                  <p>대기업 및 공공기관 납품 실적 달성</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">2010</div>
                <div className="timeline-content">
                  <h4>주식회사 서울소프트 설립</h4>
                  <p>IT 솔루션 개발 및 컨설팅 사업 시작</p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section company-info-section">
            <h2>회사 정보</h2>
            <div className="company-details">
              <div className="detail-row">
                <span className="detail-label">회사명</span>
                <span className="detail-value">주식회사 서울소프트 (Seoul-Soft Co., Ltd.)</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">대표이사</span>
                <span className="detail-value">노병진</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">사업자등록번호</span>
                <span className="detail-value">134-87-18556</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">본사 / 연구소</span>
                <span className="detail-value">충청북도 충주시 중앙로 80 (네오메디클리닉), 501호</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">서울사무소</span>
                <span className="detail-value">서울특별시 금천구 가산디지털1로 84, 810호</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">전화</span>
                <span className="detail-value">02-6052-1192</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">팩스</span>
                <span className="detail-value">02-600-9349</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">이메일</span>
                <span className="detail-value">support@seoul-soft.com</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
